import { render, staticRenderFns } from "./focus_merchandise.vue?vue&type=template&id=4a270db0&scoped=true"
import script from "./focus_merchandise.vue?vue&type=script&lang=js"
export * from "./focus_merchandise.vue?vue&type=script&lang=js"
import style0 from "./focus_merchandise.vue?vue&type=style&index=0&id=4a270db0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a270db0",
  null
  
)

export default component.exports